// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_du-b";
export var colorBlue = "_du-8";
export var colorDot = "_du-0";
export var colorDotLarge = "_du-2";
export var colorDotSmall = "_du-1";
export var colorGreen = "_du-7";
export var colorGrey = "_du-3";
export var colorOrange = "_du-5";
export var colorPink = "_du-a";
export var colorPurple = "_du-9";
export var colorRed = "_du-4";
export var colorYellow = "_du-6";